import React, { useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ImageUploader from 'react-images-upload';
import { BlueButton } from 'components/Button';
import { sendLogoImg } from 'reducers/customer/actions';
import { navigate } from '@reach/router';

const UploadContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;
const ButtonContainer = styled.div`
  align-self: center;
  text-align: center;
  margin-top: 20px;
`;

const ErrorMessage = styled.span`
  color: red;
  font-size: 14px;
  align-self: center;
`;

const ChangeLogo = ({ sendLogoImg }) => {
  const [logoImg, setLogoImg] = useState('');
  const [error, setError] = useState('');

  const submitImgLogo = async () => {
    try {
      await sendLogoImg(logoImg);
      navigate('/');
    } catch (err) {
      setError('An error occurred. Please try again');
      console.error(err);
    }
  };

  return (
    <UploadContainer>
      <ImageUploader
        withIcon={true}
        withPreview={false}
        singleImage={true}
        className="image-uploader"
        buttonClassName="upload-image-button"
        accept="accept=image/*"
        label="Max file size: 5mb, accept photo extension: jpeg | jpg | png | svg"
        buttonText="Choose Logo Image"
        onChange={(imageMetadata, [base64Img]) => setLogoImg(base64Img)}
        imgExtension={['.jpg', '.png', '.svg']}
        maxFileSize={5242880}
        fileSizeError="- image is too big. Choose another image"
        fileTypeError="- not supported file extension. Choose another image"
      />
      {error && <ErrorMessage>{error}</ErrorMessage>}
      <ButtonContainer>
        <BlueButton
          type="submit"
          padding="9px 24px"
          buttonHeight="30px"
          fontSize="14px"
          onClick={submitImgLogo}
          disabled={!logoImg}
        >
          Submit Logo Image
        </BlueButton>
      </ButtonContainer>
    </UploadContainer>
  );
};

const mapStateToProps = (state, props) => {
  return {};
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendLogoImg }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ChangeLogo);
